import { SvgIcon } from "@mui/material";
import React from "react";

export default function ReportIcon({ fill = "#fff", ...props }: any) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.16699 19.4072V3.40723C2.16699 2.94699 2.53976 2.57422 3 2.57422C3.46024 2.57422 3.83301 2.94699 3.83301 3.40723V19.4072C3.83301 19.7166 3.95601 20.0136 4.1748 20.2324C4.3936 20.4512 4.69058 20.5742 5 20.5742H21L21.085 20.5781C21.5053 20.6207 21.833 20.9757 21.833 21.4072C21.833 21.8675 21.4602 22.2402 21 22.2402H5C4.24855 22.2402 3.52745 21.9425 2.99609 21.4111C2.46474 20.8798 2.16699 20.1587 2.16699 19.4072Z"
          fill={fill}
        />
        <path
          d="M17.167 17.4072V9.40723C17.167 8.94699 17.5398 8.57422 18 8.57422C18.4602 8.57422 18.833 8.94699 18.833 9.40723V17.4072C18.833 17.8675 18.4602 18.2402 18 18.2402C17.5398 18.2402 17.167 17.8675 17.167 17.4072Z"
          fill={fill}
        />
        <path
          d="M12.167 17.4072V5.40723C12.167 4.94699 12.5398 4.57422 13 4.57422C13.4602 4.57422 13.833 4.94699 13.833 5.40723V17.4072C13.833 17.8675 13.4602 18.2402 13 18.2402C12.5398 18.2402 12.167 17.8675 12.167 17.4072Z"
          fill={fill}
        />
        <path
          d="M7.16699 17.4072V14.4072C7.16699 13.947 7.53976 13.5742 8 13.5742C8.46024 13.5742 8.83301 13.947 8.83301 14.4072V17.4072C8.83301 17.8675 8.46024 18.2402 8 18.2402C7.53976 18.2402 7.16699 17.8675 7.16699 17.4072Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
}
